import { render } from "./male.vue?vue&type=template&id=2062088c"
import script from "./male.vue?vue&type=script&lang=js"
export * from "./male.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__